export enum MbColor {
  orange = 'orange',
  violet = 'violet',
  purple = 'purple',
  grey = 'grey',
  turqouise = 'turqouise',
  blue = 'blue',
  green = 'green',
  lightOrange = 'lightOrange',
  yellow = 'yellow',
  magenta = 'magenta',
  samplePreparationYellow = 'samplePreparationYellow',
  cellSeparationBlue = 'cellSeparationBlue',
  antibodiesPurple = 'antibodiesPurple',
  flowCytometryGreen = 'flowCytometryGreen',
  imagingTeal = 'imagingTeal',
  cellCultureRed = 'cellCultureRed',
  clinicalBlue = 'clinicalBlue',
  therasorbBlue = 'therasorbBlue',
  molecularAnalysisGreen = 'molecularAnalysisGreen',
  molecularGreen = 'molecularGreen',
  black = 'black',
  white = 'white'
}
